import { Checkbox, DataSource, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLateRouteReport extends Layout {
    checkboxPageBreakAfterDispatcher: Checkbox;
    checkboxPageBreakAfterFleet: Checkbox;
    checkboxPageBreakAfterUser: Checkbox;
    checkboxPageBreakGroupBy: Checkbox;
    excludabletextboxD: ExcludableTextbox;
    excludabletextboxFleets: ExcludableTextbox;
    excludabletextboxLateStatuses: ExcludableTextbox;
    excludabletextboxUsers: ExcludableTextbox;
    sourceLateRoute: DataSource;
    textboxDates: Textbox;
    textboxGroupBy: Textbox;
}
